import React from 'react';
import { Input } from '../../ui';

interface SetVariableConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const SetVariableConfig: React.FC<SetVariableConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 dark:bg-blue-500/10 border border-blue-200 dark:border-blue-500/30 rounded-lg p-3 text-xs text-blue-700 dark:text-blue-200 leading-relaxed">
        <strong className="text-blue-800 dark:text-blue-100">Como funciona:</strong> Define ou atualiza o valor de uma variável. Essa variável fica disponível para uso em qualquer nó seguinte com <code className="bg-blue-100 dark:bg-blue-500/30 px-1 rounded text-blue-800 dark:text-blue-100">{'{{nome_variavel}}'}</code>. No modo <strong>Conversa livre</strong>, o valor permanece salvo na mesma conversa (sessão) entre execuções, até ser sobrescrito ou a sessão ser reiniciada. Útil para armazenar dados calculados, contadores ou informações fixas.
      </div>
      <Input
        label="Nome da Variável"
        placeholder="Ex: contador"
        value={config.variableName || ''}
        onChange={(e) => onChange('variableName', e.target.value.replace(/\s/g, '_'))}
      />
      <Input
        label="Valor"
        placeholder="Ex: 0 ou {{outra_variavel}}"
        value={config.value || ''}
        onChange={(e) => onChange('value', e.target.value)}
      />
    </div>
  );
};
